import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useParams } from 'react-router-dom'

// React Router 6's <Navigate to="/tutorials/:tutorialSlug"> does NOT interpolate
// the ":tutorialSlug" token — it would redirect to the literal path and 404.
// Pull the slug from the matched URL and build the real target instead, so
// legacy /videos/<slug> and /tutorials/<slug>/watch links keep their link
// equity via a client-side redirect.
export default function TutorialRedirect({ watch = false }) {
  const { tutorialSlug } = useParams()
  const target = `/tutorials/${tutorialSlug}${watch ? '?watch=1' : ''}`
  return <Navigate to={target} replace />
}

TutorialRedirect.propTypes = {
  watch: PropTypes.bool
}
